export enum CashPointEntryState {
  Opened,
  Closed,
  PreparedForClosing = 10
}

export const CashPointEntryStateLabels: { [key: number]: string } = {
  [CashPointEntryState.Opened]: "Geöffnet",
  [CashPointEntryState.Closed]: "Geschlossen",
  [CashPointEntryState.PreparedForClosing]: "Vorbereitet zum Schließen"
};
